<!--
 * @Author: zl
 * @Date: 2022-04-24 10:43:35
 * @LastEditTime: 2023-01-13 14:37:31
 * @LastEditors: zl
 * @Description: 三方巡查
-->
<template>
	<div class="Tripartite-layout filter-layout">
		<div class="filter-box mb10">
			<h3 class="text-center pdt10 mb20">
				东部新中心建设项目三方巡查报表统计
				<el-tooltip effect="light"
							placement="bottom-start">
					<svg-icon icon-class="wenhao"
							  class="custom-svg"></svg-icon>
					<template slot="content">
						<div v-html="titleTip"></div>
					</template>
				</el-tooltip>
			</h3>
			<!-- 搜索内容区域 -->
			<el-form ref="searchForm"
					 :model="searchForm"
					 size="small"
					 label-width="100px">
				<el-row :gutter="10"
						type="flex"
						justify="space-between">
					<el-col :span="9">
						<el-form-item label-width="10">
							筛选时间统计: {{ filterTime }}
						</el-form-item>
					</el-col>
					<el-col :span="15"
							class="custom-item">
						<el-form-item label="选择时间"
									  prop="month"
									  style="width:375px">
							<el-date-picker v-model="searchForm.month"
											type="monthrange"
											:clearable="false"
											format="yyyy年MM月"
											value-format="yyyy-MM"
											range-separator="-"
											start-placeholder="开始时间"
											end-placeholder="结束时间"
											placeholder="请选择月份"
											@change="monthChange"></el-date-picker>
						</el-form-item>
						<el-form-item label-width="0"
									  class="ml10">
							<el-button type="primary"
									   size="small"
									   icon="el-icon-menu"
									   @click="doFilter('top', '1098007')">列过滤</el-button>
							<el-button size="small"
									   @click="exportExcelMethod('total')">导出Excel</el-button>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<!-- 合计表格 -->
			<vxe-table align="center"
					   auto-resize
					   resizable
					   border
					   :data="tableObj.totalData"
					   highlight-current-row
					   highlight-hover-row
					   height="210px"
					   ref="topTable"
					   @cell-click="cellClick"
					   :cell-class-name="cellStyle"
					   :loading="tableObj.totalLoading"
					   show-header-overflow="tooltip"
					   show-overflow="tooltip">
				<vxe-column title="片区"
							field="typeName"
							width="100"></vxe-column>
				<vxe-column title="合计"
							field="totalCounts"
							width="100">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.totalCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="安全巡查交底表"
							field="safelyPatrolCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.safelyPatrolCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="月度巡查计划表"
							field="monthlyInspectionScheduleCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.monthlyInspectionScheduleCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="工程巡查意见书"
							field="inspectionOptionCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.inspectionOptionCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="工程巡查报告"
							field="inspectionReportCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.inspectionReportCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="工程巡查报告回复单"
							field="inspectionReportReplyCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.inspectionReportReplyCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="工程巡查月报"
							field="monthlyReportCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.monthlyReportCounts }}</strong>
						</span>
					</template>
				</vxe-column>
				<vxe-column title="工程巡查处罚单"
							field="sheetReportCounts"
							min-width="150">
					<template #default="{ row }">
						<span class="vxe-cell--label custom-cell">
							<strong>{{ row.sheetReportCounts }}</strong>
						</span>
					</template>
				</vxe-column>
			</vxe-table>
		</div>
		<div class="filter-content primary-layout">
			<!-- 内容区域 提示信息 和 导出excel、列过滤 -->
			<div class="primary-header">
				<div class="left-text">
					<span class="tips">
						<i class="el-icon-warning"></i>
						<span v-html="this.customTip()"></span>
					</span>
				</div>
				<div class="btnGroups">
					<el-input v-model="searchForm.projectName"
							  size="small"
							  placeholder="请输入项目名称"
							  clearable
							  class="custom-input-inner">
						<el-button class="btn-success"
								   size="small"
								   slot="append"
								   @click="submitForm">查询</el-button>
					</el-input>

					<!-- 弹出框搜素区域 -->
					<el-popover placement="bottom-end"
								width="415"
								trigger="click">
						<el-form ref="searchForm"
								 :model="searchForm"
								 size="small"
								 label-width="100px">
							<el-form-item label="项目类型"
										  prop="newProType">
								<el-select v-model="searchForm.newProType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxxmlx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设单位"
										  prop="constructionUnit">
								<el-select v-model="searchForm.constructionUnit"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="(item, index) in constructionUnitList"
											   :key="index"
											   :label="item.sname"
											   :value="item.ownerUnit"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="计划编排类别"
										  prop="start">
								<el-select v-model="searchForm.start"
										   placeholder="请选择">
									<el-option v-for="item in typeOptions"
											   :key="item.value"
											   :label="item.label"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="建设类型"
										  prop="constType">
								<el-select v-model="searchForm.constType"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in projectDict.dxjslx"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="三巡单位"
										  prop="patrolUnit">
								<el-select v-model="searchForm.patrolUnit"
										   placeholder="请选择"
										   clearable>
									<el-option v-for="item in tripartiteUnitList"
											   :key="item.id"
											   :label="item.sname"
											   :value="item.ownerUnit"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label="巡查类型"
										  prop="patrolType">
								<el-select v-model="searchForm.patrolType"
										   placeholder="请选择">
									<el-option v-for="item in projectDict.dxxclx"
											   :key="item.value"
											   :label="item.sname"
											   :value="item.value"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item label-width="0"
										  class="text-center borderTop">
								<el-button type="primary"
										   icon="el-icon-search"
										   @click="submitForm">查询</el-button>
								<el-button icon="el-icon-refresh"
										   @click="resetForm">重置</el-button>
							</el-form-item>
						</el-form>
						<el-button type="success"
								   size="small"
								   slot="reference"
								   icon="el-icon-arrow-down"
								   class="ml10 mr10 btn-success"></el-button>
					</el-popover>
					<el-button type="primary"
							   size="small"
							   icon="el-icon-menu"
							   @click="doFilter('bottom', '1098008')">列过滤</el-button>
					<el-button size="small"
							   @click="exportExcelMethod('list')">导出Excel</el-button>
				</div>
			</div>
			<!-- 内容表格 -->
			<div class="primary-content mt10">
				<div class="w-table-layout">
					<vxe-table align="center"
							   auto-resize
							   resizable
							   border
							   ref="patrolsTable"
							   :data="tableObj.data"
							   height="95%"
							   highlight-current-row
							   highlight-hover-row
							   :loading="tableObj.loading"
							   show-header-overflow="tooltip"
							   show-overflow="tooltip">
						<vxe-column title="序号"
									type="seq"
									width="65"></vxe-column>
						<vxe-column title="项目名称"
									field="projectName"
									header-align="center"
									align="left"
									min-width="150">
							<template #default="{ row }">
								<span class="vxe-cell--label blue-text"
									  @click="doClick(row, 'enter')">
									{{ row.projectName }}
								</span>
							</template>
						</vxe-column>
						<vxe-column title="标段名称"
									field="packName"
									header-align="center"
									align="left"
									min-width="150"
									:visible="false"></vxe-column>
						<vxe-column title="片区"
									field="isNorthName"
									width="100"></vxe-column>
						<vxe-column title="建设单位"
									field="constructionUnitName"
									min-width="150"
									header-align="center"
									align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.constructionUnitName"
											placement="top">
									<span class="vxe-cell--label">{{ row.constructionUnitShortName }}</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="计划编排类别"
									field="planType"
									width="120"></vxe-column>
						<vxe-column title="项目类型"
									field="newProTypeName"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="建设类型"
									field="constructionTypeName"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="争取开工年份"
									field="striveStartDate"
									width="120px"
									:visible="false"></vxe-column>
						<vxe-column title="表单名称"
									field="sname"
									min-width="150px"
									header-align="center"
									align="left"></vxe-column>
						<vxe-column title="表单类型"
									field="moduleTypeName"
									min-width="150px"></vxe-column>
						<vxe-column title="巡查类型"
									field="patrolTypeName"
									width="100px"></vxe-column>
						<vxe-column title="三巡单位"
									field="patrolUnitName"
									width="130px"
									header-align="center"
									align="left">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.patrolUnitName"
											placement="top">
									<span class="vxe-cell--label">
										{{ row.patrolUnitShortName }}
									</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作人"
									field="updateUserName"
									width="120px"></vxe-column>
						<vxe-column title="操作单位"
									field="tenantShortName"
									width="130px"
									header-align="center"
									align="left"
									:visible="false">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.tenantName"
											placement="top">
									<span class="vxe-cell--label">
										{{ row.tenantShortName }}
									</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作日期"
									field="updateDate"
									width="120px">
							<template #default="{ row }">
								<el-tooltip effect="dark"
											:content="row.updateDate"
											:disabled="!row.updateDate"
											placement="top">
									<span class="vxe-cell--label"
										  v-if="!!row.updateDate">
										{{ row.updateDate.substr(0, 11) }}
									</span>
									<span v-else>-</span>
								</el-tooltip>
							</template>
						</vxe-column>
						<vxe-column title="操作"
									width="180">
							<template #default="{ row }">
								<el-button type="primary"
										   round
										   plain
										   class="table-btn"
										   v-if="roleBtns.includes('view')"
										   @click="doClick(row, 'view')">
									<svg-icon icon-class="form-look"></svg-icon> 查看
								</el-button>
								<el-button type="primary"
										   round
										   plain
										   class="table-btn"
										   v-if="roleBtns.includes('enter')"
										   @click="doClick(row, 'enter')">
									<svg-icon icon-class="form-enter"></svg-icon> 进入项目
								</el-button>
							</template>
						</vxe-column>
					</vxe-table>
				</div>
			</div>
		</div>

		<!-- 查看 -->
		<PatrolsView v-if="dialogObj.show"
					 ref="PatrolsView"
					 :currentRow="dialogObj.data"
					 @sendClose="acceptClose"></PatrolsView>

		<!-- 列过滤 -->
		<ColumnFilter ref="ColumnFilter"
					  v-if="showFilter"
					  :filterColumns="filterColumns"
					  :busType="busType"
					  memory
					  @onFilter="onFilter"></ColumnFilter>
	</div>
</template>

<script>
import * as ProjectApi from 'api/projectManage/ProjectIndex'
import * as API from 'api/Patrols/PatrolsIndex'
import * as HomeApi from '@/api/home/homeIndex'
import ColumnFilter from '@/views/Common/ColumnFilter'
import PatrolsView from '@/views/PatrolsData/PatrolsView'
import { mapState } from 'vuex'
import { exportExcel } from 'utils/tools'
import { getContainerParams } from '@/api/home/homeIndex'
export default {
	name: 'TripartiteIndex',
	components: { ColumnFilter, PatrolsView },
	data() {
		return {
			// 搜索条件区域
			searchForm: {
				month: '', //月份
				startTime: '', //选择开始时间
				endTime: '', //选择结束时间
				projectName: '', //工程项目名称
				newProType: '', //项目类型
				start: '', //计划编排类别（0：新建，1：续建，2：发展）
				constructionUnit: '', //建设单位
				constType: '', //建设类型
				patrolType: '', //巡查类型
				moduleType: '', //查询类型（1:安全巡查交底表、2:月度巡查计划表、3:工程巡查意见书、4:工程巡查报告、5:工程巡查月报、6工程巡查报告回复单、8工程巡查处罚单）
				patrolUnit: '', //三方巡查单位
				ids: '', //getInspectionReportCounts接口返回的ids参数
			},
			filterTime: '', //筛选时间统计
			filterObj: {}, //筛选对象
			tableObj: {
				data: [], //详细表格数据
				loading: false, //详细表格数据loading
				totalData: [], //合计表格数据
				totalLoading: false, //合计表格数据loading
				projectNum: 0, //当前项目数
			},
			// 查看弹窗对象
			dialogObj: {
				show: false, //显隐
				data: {}, //内容
			},
			constructionUnitList: [], //建设单位列表
			tripartiteUnitList: [], //三方巡查单位列表
			showFilter: false, //列过滤弹窗显隐
			// 列过滤内容
			filterColumns: [
				{
					title: '',
					checkAll: false,
					columns: [],
				},
			],
			busType: '', //用以区分略过滤模块
			selectRowIndex: 1, // 点击单元格的rowIndex
			selectColumnIndex: 1, // 点击单元格的columnIndex
			filterFiled: '', //点击单元格的field
		}
	},
	created() {
		// 根据单位类型查询单位
		this.getCompanyList()
		// 获取当前时间(后台)
		this.getContainerParams()
		// 获取自定义列过滤 三方巡查合计表
		this.getSelfData('1098007', true)
		// 获取自定义列过滤 三方巡查项目表
		this.getSelfData('1098008', true)
	},
	methods: {
		/**
		 * @description: 准备工作
		 */

		// 获取当前时间(后台)
		getContainerParams() {
			getContainerParams({}).then((res) => {
				let currentDate = res.data.currentDate
				let endDate = this.$utils.getWhatMonth(currentDate, 0, 'last')
				endDate = this.$utils.toDateString(endDate, 'yyyy-MM-dd')
				let startDate = this.$utils.getWhatMonth(
					currentDate,
					0,
					'first'
				)
				startDate = this.$utils.toDateString(startDate, 'yyyy-MM-dd')
				this.searchForm.month = [startDate, endDate]
				this.searchForm.startTime = startDate
				this.searchForm.endTime = endDate
				// 获取投资管理统计表格数据
				this.getInspectionReportCounts(true)
				this.filterTime =
					startDate.substr(0, 7) + ' 至 ' + endDate.substr(0, 7)
			})
		},

		// 获取自定义列过滤数据
		getSelfData(busType, first) {
			let params = { busType }
			let loadingName = busType == '1098007' ? 'totalLoading' : 'loading'
			let refName = busType == '1098007' ? 'topTable' : 'patrolsTable'
			this.tableObj[loadingName] = true
			HomeApi.getSelfData(params)
				.then((res) => {
					if (res.data.length == 0) {
						return
					}
					if (this.$refs[refName]) {
						let tableShowColumn =
							this.$refs[refName].getTableColumn()
						tableShowColumn.collectColumn.forEach((x) => {
							let obj = res.data.find(
								(y) => y.field == x.property
							)
							if (obj) {
								x.visible = obj.isChecked
							}
						})
						this.$refs[refName].refreshColumn()
					}
					this.tableObj[loadingName] = false
					if (!first) {
						this.getInspectionReportCounts(true)
					}
				})
				.catch(() => {
					this.tableObj[loadingName] = false
				})
		},

		// 获取统计报表数据
		getInspectionReportCounts(first) {
			this.tableObj.totalLoading = true
			API.getInspectionReportCounts({
				startTime: this.searchForm.startTime,
				endTime: this.searchForm.endTime,
			})
				.then((res) => {
					this.tableObj.totalData = res.data
					this.tableObj.totalLoading = false
					if (first) {
						this.filterObj = this.$utils.clone(res.data[1], true)
						this.searchForm.ids = res.data[1].ids
						// 锁定 瑶海区 合计单元格 并清空 当前操作的filed
						this.selectRowIndex = 1
						this.selectColumnIndex = 1
						this.filterFiled = ''
						this.searchForm.moduleType = ''
						// 获取投资管理表格数据
						this.getTripartiteData()
					}
				})
				.catch(() => {
					this.tableObj.totalLoading = false
				})
		},

		// 获取投资管理表格数据
		getTripartiteData() {
			let params = this.$utils.clone(this.searchForm, true)
			delete params.month
			this.tableObj.loading = true
			API.getInspectionReportList(params)
				.then((res) => {
					this.tableObj.data = res.data.inspectionList
					this.tableObj.projectNum = res.data.projectCounts
					this.tableObj.loading = false
				})
				.catch(() => {
					this.tableObj.loading = false
				})
		},

		// 根据单位类型查询单位
		getCompanyList() {
			ProjectApi.selectSysTenantsByType().then((res) => {
				this.$set(this, 'constructionUnitList', res.data.SUBJECT_JSDW)
				this.$set(this, 'tripartiteUnitList', res.data.SUBJECT_SFXC)
			})
		},

		/**
		 * @description: 搜索区域操作
		 */

		// 时间change
		monthChange(data) {
			if (!data) {
				this.searchForm.startTime = ''
				this.searchForm.endTime = ''
				this.filterTime = ''
			} else {
				let endDate = this.$utils.getWhatMonth(data[1], 0, 'last')
				endDate = this.$utils.toDateString(endDate, 'yyyy-MM-dd')
				let startDate = this.$utils.getWhatMonth(data[0], 0, 'first')
				startDate = this.$utils.toDateString(startDate, 'yyyy-MM-dd')
				this.searchForm.startTime = startDate
				this.searchForm.endTime = endDate
				this.filterTime = data[0] + ' 至 ' + data[1]
			}
			// 时间变化调用统计接口
			this.getInspectionReportCounts(true)
		},

		// 表单搜索
		submitForm() {
			this.getTripartiteData()
		},

		// 重置表单
		resetForm() {
			this.$refs.searchForm.resetFields()
			this.searchForm.projectName = ''
			this.getTripartiteData()
		},

		// 点击列过滤
		doFilter(type, busType) {
			this.$set(this, 'busType', busType)
			this.showFilter = true
			// 区分 table
			let refName = type == 'top' ? 'topTable' : 'patrolsTable'
			// 获取对应 table 的列
			let tableColumn = this.$refs[refName].getTableColumn()
			let collectColumn = this.$utils.clone(
				tableColumn.collectColumn,
				true
			)
			if (type == 'bottom') {
				collectColumn.shift()
				collectColumn.pop()
			} else {
				collectColumn.shift()
				collectColumn.shift()
			}
			this.filterColumns[0].columns = collectColumn

			setTimeout(() => {
				this.$refs.ColumnFilter.dialogObj.visible = true
			}, 200)
		},

		// 确认列过滤
		onFilter(arr) {
			let refName =
				this.busType == '1098007' ? 'topTable' : 'patrolsTable'
			let loadingName =
				this.busType == '1098007' ? 'totalLoading' : 'loading'
			this.tableObj[loadingName] = true
			if (this.$refs[refName]) {
				this.$set(this, 'filterColumns', arr)
				this.getSelfData(this.busType)
				return
			}
			this.tableObj[loadingName] = false
		},

		/**
		 * @description: 表格相关操作
		 */

		// 单元格被点击触发事件
		cellClick({ row, rowIndex, column, columnIndex }) {
			let field = column.field
			if (field == 'typeName') {
				return
			}
			let obj = this.moduleTypeList.find((x) => x.field == field)
			if (obj) {
				this.searchForm.moduleType = obj.type
			} else {
				this.searchForm.moduleType = ''
			}
			// 保存当前行数据用来渲染中间的提示信息
			this.filterObj = this.$utils.clone(row, true)
			this.filterFiled = this.$utils.clone(field, true)
			// 保存 点击单元的 行下标 和 列下标 用来渲染 active 的样式
			this.selectRowIndex = rowIndex
			this.selectColumnIndex = columnIndex
			// 清空下面搜索表格的搜索条件
			this.searchForm.projectName = ''
			this.searchForm.newProType = ''
			this.searchForm.constructionUnit = ''
			this.searchForm.start = ''
			this.searchForm.constType = ''
			this.searchForm.patrolUnit = ''
			this.searchForm.patrolType = ''
			// 取出行里的 ids 用作参数
			this.searchForm.ids = row.ids
			// 根据点击的单元格获取不同的 moduleType 在调取借口
			this.getTripartiteData()
		},

		// 指定单元格赋予样式
		cellStyle({ row, rowIndex, columnIndex }) {
			if (
				rowIndex === this.selectRowIndex &&
				columnIndex === this.selectColumnIndex
			) {
				return 'custom-active-cell'
			}
		},

		// 处理提示语
		customTip() {
			let area = this.filterObj.typeName
			let formName = '三方巡查表'
			let total = this.filterObj.totalCounts
			if (![0, 1].includes(this.selectColumnIndex)) {
				let obj = this.moduleTypeList.find(
					(x) => x.field == this.filterFiled
				)
				formName = obj.name
				total = this.filterObj[this.filterFiled]
			}
			let msg =
				`统计期内${area}${formName}提交数：${total}个
				<span class="ml15 mr15"> </span>` + `项目数：${this.tableObj.projectNum}个`
			return msg
		},

		// 表格按钮点击事件
		doClick(data, type) {
			if (type == 'enter') {
				if (!this.roleBtns.includes('enter')) {
					return
				}
				let url = this.$outUrl
				let token = this.$getSessionItem('token')
				let tenantId = this.$getSessionItem('tenantId')
				let limitId = this.$getSessionItem('limitId')
				ProjectApi.getAuditWorkPower({
					projectId: data.projectId,
				}).then((res) => {
					if (res.operationCode == 1 && res.msg == 'faild') {
						this.$message.warning(res.data)
						return
					}
					window.open(
						`${url}/DxAuditWork/#/main?projectId=${data.projectId}&token=${token}&tenantId=${tenantId}&limitId=${limitId}&isDataRole=${res.data}`,
						'_blank'
					)
				})
				return
			}
			this.dialogObj.show = true
			this.dialogObj.data = this.$utils.clone(data, true)
			setTimeout(() => {
				this.$refs.PatrolsView.dialogObj.show = true
			}, 200)
		},

		// 接受弹窗关闭
		acceptClose(data) {
			this.dialogObj.show = data
			this.dialogObj.data = {}
		},

		// 导出excel 三方巡查列表导出
		exportExcelMethod(type) {
			let params = {
				startYear: this.searchForm.startTime.substr(0, 7), //筛选开始时间
				endYear: this.searchForm.endTime.substr(0, 7), //筛选结束时间
			}
			//接口返回数据
			if (type == 'list') {
				params.inspectionReportList = this.tableObj.data
			} else {
				params.inspectionReportCounts = this.tableObj.totalData
			}
			let baseUrl =
				type == 'list'
					? '/audit/audittripartiteinspection/exprotTemplateInspectionReportList'
					: '/audit/audittripartiteinspection/exprotTemplateInspectionReportCounts'
			let url = process.env.VUE_APP_BASE_URL + baseUrl
			let fileName =
				type == 'list'
					? '东部新中心建设项目三方巡查列表'
					: '东部新中心建设项目三方巡查报表统计'
			exportExcel(url, params, fileName)
		},
	},
	computed: {
		...mapState('dict', {
			projectDict: (state) => state.projectDict,
		}),

		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),

		// 计划编排类别
		typeOptions() {
			let arr = [
				{
					label: '新建项目',
					value: '0',
					id: '100086',
				},
				{
					label: '续建项目',
					value: '1',
					id: '100087',
				},
				{
					label: '开展前期',
					value: '2',
					id: '100088',
				},
			]
			return arr
		},

		// 表单类型
		moduleTypeList() {
			let arr = [
				{
					field: 'safelyPatrolCounts',
					type: '1',
					name: '安全巡查交底表',
				},
				{
					field: 'monthlyInspectionScheduleCounts',
					type: '2',
					name: '月度巡查计划表',
				},
				{
					field: 'inspectionOptionCounts',
					type: '3',
					name: '工程巡查意见书',
				},
				{
					field: 'inspectionReportCounts',
					type: '4',
					name: '工程巡查报告',
				},
				{
					field: 'monthlyReportCounts',
					type: '5',
					name: '工程巡查月报',
				},
				{
					field: 'inspectionReportReplyCounts',
					type: '6',
					name: '工程巡查报告回复单',
				},
				{
					field: 'sheetReportCounts',
					type: '8',
					name: '工程巡查处罚单',
				},
			]
			return arr
		},

		// 标题旁边的提示语
		titleTip() {
			let msg = `数据统计说明：默认展示当前月份数据统计。
						</br>
						</br>
						当选择起始月份后，则统计起止月份内的表单数。`
			return msg
		},
	},
}
</script>
<style lang='less' scoped>
.Tripartite-layout {
	height: 100%;
	.pdb20 {
		padding-bottom: 20px !important;
	}
	.tips {
		color: #e6a23c;
		font-size: 16px;
	}
	.custom-svg {
		color: #888;
	}
	.custom-item {
		display: flex;
		justify-content: flex-end;
	}
	.custom-cell {
		font-size: 16px;
		cursor: pointer !important;
	}
	.custom-cell:hover {
		color: #27a9ff;
	}
}
</style>